import { useEffect, useState } from "react";

import { useEditorFocus } from "@remirror/react";

import { FocusContext } from "./FocusContext";

export const FocusProvider = ({ children }: { children: React.ReactNode }) => {
  const [isDirectlyFocused] = useEditorFocus();
  const [isPopupOrModalFocused, setPopupOrModalFocused] = useState(false);

  useEffect(() => {
    const modalMount = document.getElementById("semantic-modal-mount-node");
    if (!modalMount) {
      return;
    }

    const focusChangeHandler = (e: FocusEvent) => {
      if (e.relatedTarget) {
        const isRelatedTargetInModal = modalMount.contains(
          e.relatedTarget as Node,
        );
        if (isRelatedTargetInModal) {
          e.preventDefault();
        }
        setPopupOrModalFocused(isRelatedTargetInModal);
      }
    };
    document.addEventListener("blur", focusChangeHandler, true);
    return () => {
      document.removeEventListener("blur", focusChangeHandler, true);
    };
  }, [isDirectlyFocused]);

  const isFocused = isDirectlyFocused || isPopupOrModalFocused;

  return (
    <FocusContext.Provider
      value={{ isFocused, isDirectlyFocused, isPopupOrModalFocused }}
    >
      {children}
    </FocusContext.Provider>
  );
};
